import { FC } from 'react';
import { Popover } from 'antd';
import { headerStore } from '@modules/header/adapter/outbound/stores/header.store';
import { userStore } from '@modules/user/adapter/outbound/stores/user.store';
import ProfileImageLogic from '@components/profile/image/ProfileImage.logic';
import { analytics } from '@shared/utils/segment.utils';
import ProfileButtonContentLogic from './Content.logic';
import { Container, ImageWrapper, Name } from './ProfileButton.style';
const ProfileButtonLogic: FC = () => {
  const {
    userDetail
  } = userStore(state => state);
  const {
    isProfilePopupOpen,
    setIsProfilePopupOpen
  } = headerStore(state => state);
  return <Popover content={<ProfileButtonContentLogic />} trigger="click" open={isProfilePopupOpen} placement="bottom">
            <Container onClick={() => {
      analytics.track('Profile Click', {
        event: 'Profile Click'
      });
      setIsProfilePopupOpen(!isProfilePopupOpen);
    }}>
                <ImageWrapper>
                    <ProfileImageLogic />
                </ImageWrapper>

                <Name>
                    {userDetail ? userDetail.firstName + ' ' + userDetail.lastName : 'name'}
                </Name>
            </Container>
        </Popover>;
};
export default ProfileButtonLogic;